/**
 * Dati condivisi dei mega menu (desktop + accordion mobile).
 * Tenere qui i contenuti evita duplicazioni tra ServicesMegaPanel,
 * ProjectsMegaPanel e l'accordion mobile dell'Header.
 */

export type Lang = "it" | "en";

export type MegaService = {
  slug: string;
  motif: string;
  title: Record<Lang, string>;
  phrase: Record<Lang, string>;
};

export const MEGA_SERVICES: MegaService[] = [
  {
    slug: "bug-fixing-ai-nocode",
    motif: "rebuild",
    title: { it: "Da no-code a prodotto", en: "No-code to product" },
    phrase: {
      it: "Salvo e rendo solido il tuo progetto Lovable, Bubble o v0.",
      en: "I rescue and harden your Lovable, Bubble or v0 project.",
    },
  },
  {
    slug: "siti-wordpress",
    motif: "target",
    title: { it: "Siti WordPress", en: "WordPress sites" },
    phrase: {
      it: "Sito su misura, veloce, fatto per farti trovare su Google.",
      en: "A tailored, fast site built to get you found on Google.",
    },
  },
  {
    slug: "wordpress-performance",
    motif: "gauge",
    title: { it: "Velocizzare WordPress", en: "WordPress speed" },
    phrase: {
      it: "Il tuo sito è lento? Trovo le cause e lo rendo veloce.",
      en: "Is your site slow? I find the causes and make it fast.",
    },
  },
  {
    slug: "ecommerce-woocommerce",
    motif: "cart",
    title: { it: "Ecommerce", en: "Ecommerce" },
    phrase: {
      it: "Un negozio online che vende davvero e resta tuo.",
      en: "An online store that really sells and stays yours.",
    },
  },
  {
    slug: "sviluppo-custom-nextjs",
    motif: "code",
    title: { it: "Web app su misura", en: "Custom web apps" },
    phrase: {
      it: "Gestionali, portali e dashboard quando WordPress non basta.",
      en: "Internal tools, portals and dashboards when WordPress is not enough.",
    },
  },
  {
    slug: "app-mobile",
    motif: "phone",
    title: { it: "App mobile", en: "Mobile apps" },
    phrase: {
      it: "Una sola app, su iPhone e Android. Codice tuo.",
      en: "One app, on iPhone and Android. Your code.",
    },
  },
  {
    slug: "automazioni-n8n-ai",
    motif: "nodes",
    title: { it: "Automazioni AI", en: "AI automations" },
    phrase: {
      it: "Tolgo il lavoro manuale che si ripete ogni giorno.",
      en: "I remove the manual work that repeats every day.",
    },
  },
  {
    slug: "siti-3d-creative",
    motif: "cube",
    title: { it: "Lab creativo / 3D", en: "Creative lab / 3D" },
    phrase: {
      it: "Esperienze 3D che le persone si ricordano.",
      en: "3D experiences people actually remember.",
    },
  },
  {
    slug: "manutenzione-evolutiva",
    motif: "cycle",
    title: { it: "Manutenzione evolutiva", en: "Ongoing maintenance" },
    phrase: {
      it: "Sito e app aggiornati e sicuri, ogni mese.",
      en: "Site and apps updated and secure, every month.",
    },
  },
];

export type MegaEntry = {
  key: string;
  href: string;
  title: Record<Lang, string>;
  phrase?: Record<Lang, string>;
  /** Voce ancora in lavorazione: non naviga, mostra il badge "In progress". */
  inProgress?: boolean;
};

/** Voci "Progetti" del mega hub. */
export function projectEntries(projectsBase: string): MegaEntry[] {
  return [
    {
      key: "all",
      href: projectsBase,
      title: { it: "Tutti i progetti", en: "All projects" },
      phrase: {
        it: "Siti, app e prodotti reali, in crescita.",
        en: "Real sites, apps and products, growing.",
      },
    },
  ];
}

/** Sezione demo, per ora in lavorazione. */
export const DEMO_ENTRY: MegaEntry = {
  key: "demo",
  href: "",
  inProgress: true,
  title: { it: "Demo interattive", en: "Interactive demos" },
  phrase: {
    it: "In lavorazione, presto qui.",
    en: "In progress, coming soon.",
  },
};

/** Strumenti / estensioni Chrome pubblicati. */
export function toolEntries(strumentiBase: string): MegaEntry[] {
  return [
    {
      key: "argus",
      href: `${strumentiBase}/estensioni-chrome/argus`,
      title: { it: "Argus", en: "Argus" },
      phrase: {
        it: "La mia estensione per Chrome.",
        en: "My Chrome extension.",
      },
    },
  ];
}
